<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                {{ selectedRideForRequest ? 'Solicitar Carona' : 'Reservar Veículo' }}
                                <span class="required_fields text-white">
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <form @submit.prevent="save">
                                        <!-- Componente de Filtros de Pesquisa -->
                                        <VehicleSearchFilters
                                            v-if="!selectedRideForRequest"
                                            v-model="reserveVehicles"
                                            :city-destinations="cityDestinations"
                                            :vehicle-types="vehicleTypes"
                                            :justifications="justifications"
                                            :branches="branches"
                                            :cost-centers="cost_centers"
                                            :network-diagrams="network_diagrams"
                                            :min-date="minDate"
                                            :max-date="maxDate"
                                            :next-week-blocked="nextWeekBlocked"
                                            :min-devolution-date="minDevolutionDate"
                                            :max-devolution-date="maxDevolutionDate"
                                            :is-searching-driver="isSearchingDriver"
                                            :is-searching-ride="isSearchingRide"
                                            :is-loading-driver-search="isLoadingDriverSearch"
                                            :is-loading-ride-search="isLoadingRideSearch"
                                            :driver-registration="driverRegistration"
                                            :ride-registration="rideRegistration"
                                            @search-vehicles="getVehicles($store.state.user.access_nivel)"
                                            @retreat-date-change="onRetreatDateChange"
                                            @close-vehicles-table="closeVehiclesTable"
                                            @get-vehicle-types="getVehicleTypes"
                                            @toggle-driver-search="isSearchingDriver = !isSearchingDriver"
                                            @toggle-ride-search="isSearchingRide = !isSearchingRide"
                                            @search-driver="searchDriverByRegistration"
                                            @search-ride="searchRideByRegistration"
                                            @verify-max-places="verifyMaxPlaces"
                                            @update:driver-registration="driverRegistration = $event"
                                            @update:ride-registration="rideRegistration = $event"
                                        />

                                        <!-- Seção de Caronas Disponíveis -->
                                        <AvailableRides
                                            v-if="loaded > 0 && availableRides.length > 0 && !isEditing"
                                            :rides="availableRides"
                                            :selected-ride="selectedRideForRequest"
                                            @select-ride="selectRideForRequest"
                                        />

                                        <!-- Componente de Seleção de Veículos -->
                                        <VehicleSelection
                                            v-if="loaded > 0 && !selectedRideForRequest"
                                            :vehicles="vehicles"
                                            :selected-vehicle-id="reserveVehicles.vehicle_id"
                                            :is-consultation-only="isConsultationOnly"
                                            @select-vehicle="selectVehicle"
                                            @show-vehicle-details="showVehicleDetails"
                                        />

                                        <SharedReservationSettings
                                            v-if="reserveVehicles.vehicle_id && !selectedRideForRequest"
                                            v-model="reserveVehicles"
                                            :drivers="filteredDriversByExecutive"
                                            :rides="rides"
                                            :users="users"
                                            :show-approver="showApprover"
                                            :is-searching-driver="isSearchingDriver"
                                            :is-searching-ride="isSearchingRide"
                                            :is-loading-driver-search="isLoadingDriverSearch"
                                            :is-loading-ride-search="isLoadingRideSearch"
                                            :driver-registration="driverRegistration"
                                            :ride-registration="rideRegistration"
                                            @toggle-driver-search="isSearchingDriver = !isSearchingDriver"
                                            @toggle-ride-search="isSearchingRide = !isSearchingRide"
                                            @search-driver="searchDriverByRegistration"
                                            @search-ride="searchRideByRegistration"
                                            @verify-max-places="verifyMaxPlaces"
                                            @update:driver-registration="driverRegistration = $event"
                                            @update:ride-registration="rideRegistration = $event"
                                        />

                                        <!-- Formulário de Solicitação de Carona -->
                                        <SharedReservationSettings
                                            v-if="selectedRideForRequest"
                                            v-model="rideRequestData"
                                            :is-ride-request="true"
                                            :selected-ride="selectedRideForRequest"
                                            @input="updateRideRequestData"
                                        />

                                        <!-- Botões de Ação -->
                                        <div
                                            class="row"
                                            v-if="(vehicles && hasAvailableVehicles && reserveVehicles.vehicle_id !== '') || selectedRideForRequest"
                                        >
                                            <div class="col-12 text-end">
                                                <div
                                                    class="row"
                                                    align="right"
                                                >
                                                    <div class="col-md-12">
                                                        <button
                                                            type="submit"
                                                            class="btn btn-add"
                                                            :disabled="isLoading || (selectedRideForRequest && !rideRequestData.message)"
                                                            @click.prevent="selectedRideForRequest ? requestRide() : save()"
                                                        >
                                                            <i
                                                                class="fa fa-spinner fa-spin mr-2"
                                                                v-if="isLoading"
                                                            ></i>
                                                            <i
                                                                :class="selectedRideForRequest ? 'fa fa-paper-plane mr-2' : 'fa fa-save mr-2'"
                                                                v-else
                                                            ></i>
                                                            {{ isLoading ? (selectedRideForRequest ? 'Enviando...' : 'Salvando...') : (selectedRideForRequest ? 'Solicitar Carona' : 'Salvar') }}
                                                        </button>
                                                        <button
                                                            v-if="selectedRideForRequest"
                                                            type="button"
                                                            class="btn btn-back"
                                                            @click="cancelRideRequest"
                                                        >
                                                            <i class="fa fa-times mr-2"></i>
                                                            Cancelar Solicitação
                                                        </button>
                                                        <router-link
                                                            v-else
                                                            to="/reserveVehicles"
                                                            class="btn btn-back"
                                                        >
                                                            <i class="fa fa-arrow-left mr-2"></i>
                                                            Voltar
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Detalhes do Veículo -->
        <VehicleDetailsModal
            :vehicle="selectedVehicleDetails"
            :show="showVehicleModal"
            @close="closeVehicleModal"
        />

        <!-- Loading Overlay -->
        <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        ></loading>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {fetchGet, fetchPost} from "../../composables/api";
import {getMessage} from "../../composables/message";

import VehicleSearchFilters from './add-components/VehicleSearchFilters.vue';
import VehicleSelection from './add-components/VehicleSelection.vue';
import VehicleDetailsModal from './add-components/VehicleDetailsModal.vue';
import SharedReservationSettings from "./add-components/SharedReservationSettings.vue";
import AvailableRides from './add-components/AvailableRides.vue';

export default {
    name: 'VehicleReservationForm',
    components: {
        SharedReservationSettings,
        BaseCrud,
        Loading,
        VehicleSearchFilters,
        VehicleSelection,
        VehicleDetailsModal,
        AvailableRides,
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            showVehicleModal: false,
            selectedVehicleDetails: null,

            isSearchingDriver: false,
            isSearchingRide: false,
            isLoadingDriverSearch: false,
            isLoadingRideSearch: false,
            driverRegistration: '',
            rideRegistration: '',

            maxDevolutionDate: '',
            minDevolutionDate: '',
            maxDate: '',
            minDate: '',
            nextWeekBlocked: false,

            loaded: 0,
            showApprover: false,
            selectedPlaces: 0,

            reserveVehicles: {
                id: null,
                approver_id: "",
                RetreatDatetime: "",
                DevolutionDatetime: "",
                reason: "",
                branch_id: "",
                vehicle_type_id: "",
                vehicle_id: "",
                reserve_status: "1",
                justification_id: "",
                km_provided: "",
                cityDestination_id: "",
                shared_reservation: true,
                is_driver: true,
                driver_id: null,
                reason_not_shared: "",
                network_diagram: null,
                cost_center_id: null,
                ride: [],
            },

            cityDestinations: [],
            users: [],
            drivers: [],
            branches: [],
            vehicleTypes: [],
            justifications: [],
            rides: [],
            vehicles: {
                is_shared: [],
                not_shared: [],
            },
            cost_centers: [],
            network_diagrams: [],
            pendingVehicleTypeId: null,
            selectedVehicle: null,
            availableRides: [],
            selectedRideForRequest: null,
            rideRequestData: {
                message: ''
            },
            selectedVehicleIsExecutive: false,
        };
    },
    computed: {
        isConsultationOnly() {
            const userLevel = this.$store.state.user ? this.$store.state.user.access_nivel : 1;
            return userLevel && (userLevel === 3 || userLevel === 4);
        },
        hasAvailableVehicles() {
            return this.vehicles && (
                (this.vehicles.is_shared && this.vehicles.is_shared.length > 0) || (this.vehicles.not_shared && this.vehicles.not_shared.length > 0));
        },
        filteredDriversByExecutive() {
            // Se não há veículo selecionado ou o veículo não é executivo, retorna todos os motoristas
            if (!this.selectedVehicleIsExecutive) {
                return this.drivers;
            }

            // Se o veículo é executivo, filtra apenas motoristas com flag is_executive
            return this.drivers.filter(driver => driver.is_executive === true || driver.is_executive === 1);
        },
        isEditing() {
            // Verifica se existe um ID na rota, indicando que é edição
            return !!this.$route.params.id;
        }
    },
    methods: {
        async searchUser(matriculation, isDriver = false) {
            const api = `${this.$store.state.api}users/copacol-user/${matriculation}${isDriver ? '?check_driver=true' : ''}`;
            try {
                const response = await this.$http.get(api);
                return response.data.data;
            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
                return null;
            }
        },

        async searchDriverByRegistration() {
            this.isLoadingDriverSearch = true;
            const result = await this.searchUser(this.driverRegistration, true);

            if (result) {
                // Verifica se o veículo selecionado é executivo
                if (this.selectedVehicleIsExecutive && !result.is_executive) {
                    this.$message("Erro", "Este motorista não possui permissão para dirigir veículos executivos", "error");
                } else {
                    this.$message("Sucesso", "Motorista encontrado com sucesso", "success");
                    this.drivers.push(result);
                    this.reserveVehicles.driver_id = result.id;
                }
            }

            setTimeout(() => {
                this.isLoadingDriverSearch = false;
            }, 200);
        },

        async searchRideByRegistration() {
            this.isLoadingRideSearch = true;
            const result = await this.searchUser(this.rideRegistration);

            if (result) {
                this.$message("Sucesso", "Passageiro encontrado com sucesso", "success");
                this.rides.push(result);
                this.reserveVehicles.ride.push(result.id);
            }

            setTimeout(() => {
                this.isLoadingRideSearch = false;
            }, 200);
        },

        getMondayOfWeek(date) {
            const d = new Date(date);
            const day = d.getDay(); // 0 = domingo ... 6 = sábado
            const diff = day === 0 ? -6 : 1 - day; // dias até a segunda-feira da semana corrente
            d.setDate(d.getDate() + diff);
            d.setHours(0, 0, 0, 0);
            return d;
        },

        getMaxDate() {
            // Regra: as reservas da semana subsequente só são liberadas a partir das 07h00
            // de segunda-feira. Antes disso (madrugada de segunda), limita à sexta-feira da
            // semana corrente. O backend (ValidateReserveDates) é a validação definitiva.
            const now = new Date();
            const monday = this.getMondayOfWeek(now);

            const release = new Date(monday);
            release.setHours(7, 0, 0, 0); // segunda-feira 07h00 da semana corrente

            const nextWeekReleased = now >= release;
            this.nextWeekBlocked = !nextWeekReleased;

            const date = new Date(monday);
            // Semana seguinte liberada: sexta-feira da semana seguinte (segunda + 11 dias).
            // Semana seguinte ainda não liberada: sexta-feira da semana corrente (segunda + 4 dias).
            date.setDate(monday.getDate() + (nextWeekReleased ? 11 : 4));
            date.setHours(23, 59, 59);

            this.maxDate = this.formatDateTime(date);
        },

        getMinDate() {
            const now = new Date();
            this.minDate = this.formatDateTime(now);
        },

        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            const second = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hour}:${min}:${second}`;
        },

        convertBrazilianDateToISO(dateStr) {
            // Converte formato DD/MM/YYYY HH:mm:ss para YYYY-MM-DD HH:mm:ss
            if (!dateStr) return '';

            // Se já estiver no formato correto, retorna como está
            if (dateStr.includes('-')) return dateStr;

            const parts = dateStr.split(' ');
            if (parts.length !== 2) return dateStr;

            const dateParts = parts[0].split('/');
            if (dateParts.length !== 3) return dateStr;

            const [day, month, year] = dateParts;
            const time = parts[1];

            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')} ${time}`;
        },

        getMaxDevolutionDate(retreatDate) {
            if (!retreatDate) {
                this.maxDevolutionDate = '';
                this.minDevolutionDate = '';
                return;
            }

            const retreat = new Date(retreatDate);

            const minDevolution = new Date(retreat);
            minDevolution.setHours(retreat.getHours() + 1);
            this.minDevolutionDate = this.formatDateTime(minDevolution);

            const retreatDay = retreat.getDay();
            let daysToAdd;

            if (retreatDay === 1) {
                daysToAdd = 7;
            } else if (retreatDay === 0) {
                daysToAdd = 1;
            } else {
                daysToAdd = (7 - retreatDay) + 1;
            }

            const maxDevolutionDate = new Date(retreat);
            maxDevolutionDate.setDate(retreat.getDate() + daysToAdd);
            maxDevolutionDate.setHours(7, 0, 0);

            this.maxDevolutionDate = this.formatDateTime(maxDevolutionDate);
        },

        onRetreatDateChange() {
            this.closeVehiclesTable();
            this.getMaxDevolutionDate(this.reserveVehicles.RetreatDatetime);

            if (this.reserveVehicles.DevolutionDatetime && this.maxDevolutionDate && this.minDevolutionDate) {
                const currentDevolution = new Date(this.reserveVehicles.DevolutionDatetime);
                const maxDevolution = new Date(this.maxDevolutionDate);
                const minDevolution = new Date(this.minDevolutionDate);

                if (currentDevolution > maxDevolution || currentDevolution < minDevolution) {
                    this.reserveVehicles.DevolutionDatetime = '';
                }
            }
        },

        verifyMaxPlaces() {
            if (this.reserveVehicles.ride.length > this.selectedPlaces - 1) {
                this.$message(null, 'Você já atingiu o máximo de caroneiros possível', "error");
                this.reserveVehicles.ride.pop();
            }
        },

        selectVehicle(vehicleData) {
            this.reserveVehicles.vehicle_id = vehicleData.id;
            this.selectedPlaces = vehicleData.places;
            this.showApprover = vehicleData.requiresApprover;
            this.selectedVehicleIsExecutive = vehicleData.is_executive || false;

            // Deseleção (ex: troca de origem do veículo): apenas zera o estado,
            // sem ajustar passageiros nem exibir avisos.
            if (!vehicleData.id) {
                return;
            }

            // Ajustar passageiros automaticamente quando trocar de veículo
            const maxPassengers = vehicleData.places - 1; // Número de lugares - 1 (motorista)

            if (this.reserveVehicles.ride && this.reserveVehicles.ride.length > maxPassengers) {
                // Remove passageiros excedentes (mantém os primeiros selecionados)
                const removedPassengers = this.reserveVehicles.ride.splice(maxPassengers);

                // Remove também do array de rides (objetos dos passageiros)
                if (this.rides && this.rides.length > 0) {
                    this.rides = this.rides.filter(ride => this.reserveVehicles.ride.includes(ride.id));
                }

                // Exibe mensagem informativa
                const passengerWord = removedPassengers.length === 1 ? 'passageiro' : 'passageiros';
                this.$message(
                    'Ajuste Automático',
                    `${removedPassengers.length} ${passengerWord} removido(s) automaticamente. O veículo selecionado suporta apenas ${maxPassengers} passageiro(s).`,
                    'warning'
                );
            }
        },

        showVehicleDetails(vehicle) {
            this.selectedVehicleDetails = vehicle;
            this.showVehicleModal = true;
        },

        closeVehicleModal() {
            this.showVehicleModal = false;
            this.selectedVehicleDetails = null;
        },

        makeFormData() {
            const fd = new FormData();

            fd.append("retreat_date", this.reserveVehicles.RetreatDatetime || '');
            fd.append("devolution_date", this.reserveVehicles.DevolutionDatetime || '');
            fd.append("reason", this.reserveVehicles.reason);
            if (this.reserveVehicles.approver_id) fd.append("approver_id", this.reserveVehicles.approver_id);
            fd.append("branch_id", this.reserveVehicles.branch_id);
            if (this.reserveVehicles.vehicle_type_id) fd.append("vehicle_type_id", this.reserveVehicles.vehicle_type_id);
            fd.append("vehicle_id", this.reserveVehicles.vehicle_id);
            fd.append("reserve_status", this.reserveVehicles.reserve_status);
            fd.append("justification_id", this.reserveVehicles.justification_id);
            fd.append("km_provided", this.reserveVehicles.km_provided);
            fd.append("cityDestination_id", this.reserveVehicles.cityDestination_id);
            if (this.reserveVehicles.cost_center_id) fd.append("cost_center_id", typeof this.reserveVehicles.cost_center_id === 'object' ? this.reserveVehicles.cost_center_id.id : this.reserveVehicles.cost_center_id);
            if (this.reserveVehicles.network_diagram) fd.append("network_diagram_id", typeof this.reserveVehicles.network_diagram === 'object' ? this.reserveVehicles.network_diagram.id : this.reserveVehicles.network_diagram);
            fd.append("shared_reservation", this.reserveVehicles.shared_reservation ? '1' : '0');
            fd.append("is_driver", this.reserveVehicles.is_driver ? '1' : '0');
            fd.append("user_id", this.reserveVehicles.user_id ? this.reserveVehicles.user_id : this.$store.state.user.id);
            fd.append("required_approver", this.showApprover ? '1' : '0');

            if (this.reserveVehicles.driver_id) {
                fd.append("driver_id", this.reserveVehicles.driver_id);
            }

            if (!this.reserveVehicles.shared_reservation) {
                fd.append("reason_not_shared", this.reserveVehicles.reason_not_shared);
            } else {
                this.reserveVehicles.ride.forEach(el => {
                    fd.append("rides[]", el);
                });
            }

            if (this.reserveVehicles.id) {
                fd.append("id", this.reserveVehicles.id);
                fd.append("_method", "PUT");
            }

            return fd;
        },

        async save() {
            this.isLoading = true;

            try {
                let api = this.$store.state.api + "reserveVehicles";
                const fd = this.makeFormData();

                if (this.reserveVehicles.id) {
                    api += "/" + this.reserveVehicles.id;
                }

                await this.$http.post(api, fd);
                this.$message("Sucesso", "Informações guardadas com sucesso", "success");
                this.$router.push("/reserveVehicles");
            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            } finally {
                this.isLoading = false;
            }
        },

        closeVehiclesTable() {
            this.loaded = 0;
            this.vehicles = {is_shared: [], not_shared: []};
            this.reserveVehicles.vehicle_id = "";
            this.availableRides = [];
            this.selectedRideForRequest = null;
        },

        selectRideForRequest(ride) {
            this.selectedRideForRequest = ride;
            // Limpa seleção de veículo
            this.reserveVehicles.vehicle_id = "";
            // Reseta dados do formulário de carona
            this.rideRequestData = {
                message: ''
            };
            // Rola a página para o formulário
            this.$nextTick(() => {
                const element = document.querySelector('.shared-reservation-settings');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },

        cancelRideRequest() {
            this.selectedRideForRequest = null;
            this.rideRequestData = {
                message: ''
            };
        },

        updateRideRequestData(data) {
            this.rideRequestData = data;
        },

        async requestRide() {
            if (!this.selectedRideForRequest || !this.rideRequestData.message) return;

            this.isLoading = true;
            try {
                const api = this.$store.state.api + "rides/request";

                // Pega o city_id da reserva selecionada
                let cityId = null;
                if (this.selectedRideForRequest.cityDestination && this.selectedRideForRequest.cityDestination.city_id) {
                    cityId = this.selectedRideForRequest.cityDestination.city_id;
                } else if (this.selectedRideForRequest.city_destination && this.selectedRideForRequest.city_destination.city_id) {
                    cityId = this.selectedRideForRequest.city_destination.city_id;
                } else {
                    // Se não tiver, usa o city_id do formulário atual
                    cityId = this.reserveVehicles.cityDestination_id;
                }

                const data = {
                    reserve_id: this.selectedRideForRequest.id,
                    requester_observation: this.rideRequestData.message,
                    city_id: cityId,
                    reserve: {
                        user_id: this.selectedRideForRequest.user_id
                    }
                };

                await this.$http.post(api, data);
                this.$message("Sucesso", "Solicitação de carona enviada com sucesso", "success");
                this.$router.push("/reserveVehicles");
            } catch (error) {
                const message = error.response && error.response.data ? error.response.data : "Erro ao solicitar carona";
                this.$message(null, message, "error");
            } finally {
                this.isLoading = false;
            }
        },

        async getVehicleTypes() {
            const endpoint = "vehicleTypes/filter";
            const data = {
                km_provided: this.reserveVehicles.km_provided,
            };

            const result = await fetchPost(endpoint, data);
            if (result) {
                this.vehicleTypes = result.data;
                const query = this.$route.query;


                if (query.vehicle_type_id) {
                    this.vehicleTypes.forEach(el => {
                        if (el.id === parseInt(query.vehicle_type_id)) {
                            this.reserveVehicles.vehicle_type_id = parseInt(query.vehicle_type_id);
                        }
                    })
                }
            }

        },

        async getVehicles(access_nivel) {
            this.isLoading = true;

            try {
                const route = (access_nivel == 3 || access_nivel == 4) ?
                    "vehiclesAvailable/" : "vehiclesAvailableMobile/";
                const api = this.$store.state.api + route;

                const fd = new FormData();
                fd.append("retreat_date", this.reserveVehicles.RetreatDatetime || '');
                fd.append("devolution_date", this.reserveVehicles.DevolutionDatetime || '');
                fd.append("_method", "GET");
                fd.append("vehicle_type_id", this.reserveVehicles.vehicle_type_id);
                fd.append("justification_id", this.reserveVehicles.justification_id ? this.reserveVehicles.justification_id : '');
                fd.append("reason", this.reserveVehicles.reason);
                fd.append("user_id", this.$store.state.user.id);
                fd.append("cityDestination_id", this.reserveVehicles.cityDestination_id);
                if (this.reserveVehicles.cost_center_id) {
                    fd.append("cost_center_id", typeof this.reserveVehicles.cost_center_id === 'object' ? this.reserveVehicles.cost_center_id.id : this.reserveVehicles.cost_center_id);
                }
                if (this.reserveVehicles.network_diagram) {
                    fd.append("network_diagram_id", typeof this.reserveVehicles.network_diagram === 'object' ? this.reserveVehicles.network_diagram.id : this.reserveVehicles.network_diagram);
                }
                if (this.reserveVehicles.id) fd.append("reserve_id", this.reserveVehicles.id);
                fd.append("branch_id", this.reserveVehicles.branch_id);
                fd.append("request_origin", "WEB");

                const response = await this.$http.post(api, fd);
                this.vehicles = response.data.data || {not_shared: [], is_shared: []};
                this.loaded = response.data.loaded;

                // Armazena as reservas disponíveis para carona
                if (response.data.data && response.data.data.reserves) {
                    this.availableRides = response.data.data.reserves;
                }

                this.restoreVehicleSelectionFromDashboard();
            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            } finally {
                this.isLoading = false;
            }
        },

        restoreVehicleSelectionFromDashboard() {

            if (this.selectedVehicle) {
                const targetVehicleId = parseInt(this.selectedVehicle);

                // Busca o veículo nos resultados da pesquisa
                let foundVehicle = null;
                let vehicleData = null;

                // Procura em veículos compartilhados
                if (this.vehicles.is_shared && this.vehicles.is_shared.length > 0) {
                    foundVehicle = this.vehicles.is_shared.find(v => v.id === targetVehicleId);
                    if (foundVehicle) {
                        vehicleData = {
                            id: foundVehicle.id,
                            places: foundVehicle.places,
                            requiresApprover: foundVehicle.requires_approver,
                            is_executive: foundVehicle.is_executive
                        };
                    }
                }

                // Se não encontrou em compartilhados, procura em não compartilhados
                if (!foundVehicle && this.vehicles.not_shared && this.vehicles.not_shared.length > 0) {
                    foundVehicle = this.vehicles.not_shared.find(v => v.id === targetVehicleId);
                    if (foundVehicle) {
                        vehicleData = {
                            id: foundVehicle.id,
                            places: foundVehicle.places,
                            requiresApprover: foundVehicle.requires_approver,
                            is_executive: foundVehicle.is_executive
                        };
                    }
                }

                console.log(vehicleData)

                // Se encontrou o veículo, seleciona automaticamente
                if (vehicleData) {
                    this.selectVehicle(vehicleData);
                }
            }
        },

        async getCostCenters() {
            const result = await fetchGet("cost-centers", {paginated: false});
            if (result.status) this.cost_centers = result.data.data;
        },

        async getNetworkDiagrams() {
            const result = await fetchGet("network-diagrams", {paginated: false});
            if (result.status) this.network_diagrams = result.data.data;
        },

        async getUsers() {
            const result = await fetchGet("users", {paginated: false, is_approver: 1});
            if (result.status) this.users = result.data.data;
        },

        async getDrivers() {
            const result = await fetchGet("users", {paginated: false});
            if (result.status) this.drivers = result.data.data;
        },

        async getBranches() {
            try {
                const api = this.$store.state.api + 'branches?paginated=false&page=1';
                const response = await this.$http.get(api);
                this.branches = response.data.data;
            } catch (error) {
                const message = error.response.data.errors ?
                    getMessage(error.response.data.errors) : error.response.data;
                this.$message(null, message, "error");
            }
        },

        async getJustifications() {
            const result = await fetchGet("justifications");
            if (result.status) this.justifications = result.data.data;
        },

        async getCityDestinations() {
            const result = await fetchGet("city-destinations/reserve");
            if (result.status) {
                let cities = result.data.data;
                cities.forEach(element => {
                    element.description = element.description.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                });
                this.cityDestinations = cities;
            }
        },

        async getRides() {
            const result = await fetchGet("users", {
                paginated: false,
                select: ['id', 'name']
            });
            if (result.status) this.rides = result.data.data;
        },

        async getReserveVehicles(id) {
            const result = await fetchGet("reserveVehicles/" + id);
            if (result.status) {
                this.reserveVehicles = result.data;
                // Mapear corretamente as datas da API para os campos do formulário
                // Converte do formato brasileiro para ISO se necessário
                this.reserveVehicles.RetreatDatetime = this.convertBrazilianDateToISO(result.data.retreat_date);
                this.reserveVehicles.DevolutionDatetime = this.convertBrazilianDateToISO(result.data.devolution_date);
                this.reserveVehicles.cityDestination_id = result.data.city_destination.city_id;
                this.reserveVehicles.cost_center_id = result.data.cost_center ? result.data.cost_center.id : null;
                this.reserveVehicles.reserve_status = result.data.reserve_status.id;
                this.reserveVehicles.vehicle_type_id = result.data.vehicle_type_id.id;
                this.selectedVehicle = result.data.vehicles.id;
                await this.getVehicleTypes();
                await this.getVehicles(this.$store.state.user.access_nivel);
            }
        },

        async initializeData() {
            const promises = [
                this.getMinDate(),
                this.getMaxDate(),
                this.getDrivers(),
                this.getUsers(),
                this.getCostCenters(),
                this.getNetworkDiagrams(),
                this.getJustifications(),
                this.getVehicleTypes(),
                this.getCityDestinations(),
                this.getBranches(),
                this.getRides(),
            ];

            await Promise.all(promises);

            if (this.$store.state.user.inform_city_on_reservation) {
                this.reserveVehicles.km_provided = 1;
            }

            const id = this.$route.params.id;
            if (id) {
                await this.getReserveVehicles(id);
            } else {
                this.preloadFromDashboard();
            }
        },

        preloadFromDashboard() {
            const query = this.$route.query;

            if (query.vehicle_id) {
                this.reserveVehicles.vehicle_id = query.vehicle_id;
                this.selectedVehicle = query.vehicle_id;
            }

            if (query.retreat_date) {
                this.reserveVehicles.RetreatDatetime = query.retreat_date;
                this.getMaxDevolutionDate(query.retreat_date);
            }

            if (query.devolution_date) {
                this.reserveVehicles.DevolutionDatetime = query.devolution_date;
            }

            if (query.branch_id) {
                this.reserveVehicles.branch_id = parseInt(query.branch_id);
            }

            if (query.cost_center_id) {
                this.reserveVehicles.cost_center = parseInt(query.cost_center_id);
            }
        },
    },
    async mounted() {
        await this.initializeData();
    },
};
</script>

<style scoped>
.vehicle-selection a {
    text-decoration: none;
    color: inherit;
}

.required {
    color: #dc3545;
}

.required_fields {
    font-size: 12px;
    float: right;
}

.btn-add {
    background-color: #28a745;
    border-color: #28a745;
    color: white;
}

.btn-add:hover {
    background-color: #218838;
    border-color: #1e7e34;
}

.btn-back {
    background-color: #6c757d;
    border-color: #6c757d;
    color: white;
    margin-left: 10px;
}

.btn-back:hover {
    background-color: #5a6268;
    border-color: #545b62;
}

.card {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.form-group {
    margin-bottom: 1rem;
}

.text-end {
    text-align: right;
}

@media (max-width: 768px) {
    .text-end {
        text-align: center;
        margin-top: 1rem;
    }

    .btn-back {
        margin-left: 0;
        margin-top: 10px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/Add.vue